import { Component } from '@angular/core';

@Component({
    selector: 'app-go-to-download-location',
    templateUrl: './go-to-download-location.component.html',
    styleUrls: ['./go-to-download-location.component.scss'],
    standalone: false
})
export class GoToDownloadLocationComponent {
  constructor() {}
}
